interface IconHotelBuildingProps {
  active?: boolean;
}
export const IconHotelBuilding = ({ active }: IconHotelBuildingProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9 20.9999H5.7C3.9 20.9999 3 20.0999 3 18.2999V11.0999C3 9.2999 3.9 8.3999 5.7 8.3999H10.2V18.2999C10.2 20.0999 11.1 20.9999 12.9 20.9999Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2992 4.80005C10.2272 5.07005 10.2002 5.36705 10.2002 5.70005V8.40005H5.7002V6.60005C5.7002 5.61005 6.5102 4.80005 7.5002 4.80005H10.2992Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7998 8.3999V12.8999"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3999 8.3999V12.8999"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4998 16.5H14.6998C14.2048 16.5 13.7998 16.905 13.7998 17.4V21H17.3998V17.4C17.3998 16.905 16.9948 16.5 16.4998 16.5Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6001 12.8999V16.4999"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2002 18.3V5.7C10.2002 3.9 11.1002 3 12.9002 3H18.3002C20.1002 3 21.0002 3.9 21.0002 5.7V18.3C21.0002 20.1 20.1002 21 18.3002 21H12.9002C11.1002 21 10.2002 20.1 10.2002 18.3Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
